import { useMutation } from 'react-query';

import { reorderRankForStoredFilterBulkAssignToUser as mutationFn } from 'api/endPoints/reorderRankForStoredFilterBulkAssignToUser';

export const useMutationReorderRankForStoredFilterBulkAssignToUser = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    idList: { id: number; rank: number }[];
    contractId: number;
}
